import { Component } from 'react';
import { connect } from 'react-redux';

import dayjs from 'dayjs';

import axios from '../axios';

import { DATE_FORMAT } from '../constants/common';

import { fetchNotifications } from '../redux/actions/notifications';

import TableAlerts from '../components/Tables/TableAlerts';

function SimpleAlerts(props) {
  let rows = [];

  for (let d of props.data.slice(0, 10)) {
    rows.push(
      <li className="simple-alerts-item">
        <b>[{dayjs(d.created_at).format(DATE_FORMAT.DATE)}]</b> {d.message}
      </li>
    );
  }
  if (props.data.length === 0) {
    rows.push(<li>No alerts triggered.</li>);
  }
  return <ul className="simple-alerts">{rows}</ul>;
}

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      props: this.props
    };
    this.getData = this.getData.bind(this);
    this.snoozeNotification = this.snoozeNotification.bind(this);
    this.clearNotification = this.clearNotification.bind(this);
  }

  async componentDidMount() {
    this.getData();
  }

  async getData() {
    const data = this.props.getNotifications({
      ...this.state.props.query
    });
    if (this.props.filter && typeof this.props.filter.filter !== 'undefined') {
      this.setState(state => ({
        data: data.notifications?.filter(i => this.props.filter.filter(i))
      }));
    } else {
      this.setState(state => ({
        data: data.notifications
      }));
    }
  }

  async snoozeNotification(id) {
    let response;
    try {
      response = await axios.put('notifications/' + id + '/snooze');
    } catch (error) {
      console.error(error);
    }

    if (response?.status === 200) {
      this.getData();
    }
  }

  async clearNotification(id) {
    let response;
    try {
      response = await axios.put('notifications/' + id + '/clear');
    } catch (error) {
      console.error(error);
    }

    if (response?.status === 200) {
      this.getData();
    }
  }

  render() {
    if (this.state.props.type === 'simple') {
      return <SimpleAlerts data={this.state.data} props={this.state.props} />;
    } else {
      return (
        <TableAlerts
          data={this.state.data}
          props={this.state.props}
          onClearClick={this.clearNotification}
          onSnoozeClick={this.snoozeNotification}
        />
      );
    }
  }
}

export default connect(
  state => ({
    alerts: state?.notification?.alerts
  }),
  dispatch => ({
    getNotifications: params => {
      return dispatch(fetchNotifications(params));
    }
  })
)(Alerts);
